export const getRequestOTPData = state => state.auth.otp.data;
export const getRequestOTPMsg = state => state.auth.otp.erro_msg;

export const getAccessToken = (state, appInfo) => {
    if(appInfo && state.auth.token.access_token)
        return state.auth.token.access_token[appInfo.gate + "_" + appInfo.appid]
    return {}
}
export const getVerifyOTPMsg = state => state.auth.token.erro_msg;

export const getLoading = state => state.auth.otp.isLoading || state.auth.token.isLoading;

export const getUserData = (state, appInfo) => {
    if(appInfo && state.auth.user.data)
        return state.auth.user.data[appInfo.gate + "_" + appInfo.appid]

    return undefined
};
